import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    backgroundColor: '#EFF6F9',
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

export default {};
